import { useState } from 'react'
import { useParams, NavLink, Outlet } from 'react-router-dom'
import { PageHeader } from '@/components/layout'
import { cn } from '@/lib/utils'

const tabs = [
  { label: 'General', href: '' },
  { label: 'Branding', href: '/branding' },
  { label: 'Domains', href: '/domains' },
  { label: 'Authentication', href: '/auth' },
  { label: 'Payments', href: '/payments' },
  { label: 'Danger Zone', href: '/danger' },
]

export function SettingsLayout() {
  const { orgSlug } = useParams()
  const baseUrl = `/orgs/${orgSlug}/settings`

  return (
    <div>
      <PageHeader
        title="Settings"
        description="Manage your organization settings"
      />

      {/* Tabs */}
      <div className="border-b border-[var(--border-subtle)] mb-6">
        <nav className="-mb-px flex gap-1">
          {tabs.map((tab) => (
            <NavLink
              key={tab.href}
              to={`${baseUrl}${tab.href}`}
              end={tab.href === ''}
              className={({ isActive }) =>
                cn(
                  'border-b-2 px-4 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'border-[var(--accent)] text-[var(--accent)]'
                    : 'border-transparent text-[var(--text-secondary)] hover:border-[var(--border-default)] hover:text-[var(--text-primary)]'
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet />
    </div>
  )
}
